export default __webpack_public_path__ + "98d90ad28ccfd14c685180ecc7d778fc.png";